var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.titles[21].num && _vm.activeInfo
        ? _c(
            "title-block",
            { attrs: { id: "bm" + _vm.titles[21].label } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[21].label)),
              ]),
              _c(
                "div",
                { staticClass: "mt-10" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.bidData,
                        "header-cell-style": {
                          background: "#fafafa",
                          color: "#333",
                        },
                        "tooltip-effect": "light",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", align: "center", width: "50" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var $index = ref.$index
                                return [
                                  _c("span", [_vm._v(_vm._s($index + 1))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3973053456
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "发布时间",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [_vm._v(_vm._s(row.pubDate))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2599742359
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "公告名称",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(row.announcementName)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3896075522
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "信息分类",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [_vm._v(_vm._s(row.infoType))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2501355730
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "地区",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(row.provinceName) +
                                        _vm._s(row.cityName)
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3009333243
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDetail(row)
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1498845701
                        ),
                      }),
                    ],
                    1
                  ),
                  _c("pagination", {
                    attrs: {
                      pageNum: _vm.titles[21].pageNum,
                      total: _vm.titles[21].total,
                    },
                    on: { currentChange: _vm.getTenderPage },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.dialogShow !== null
        ? _c("DialogBidDetail", {
            attrs: { data: _vm.currentBidData, show: _vm.dialogShow },
            on: {
              "update:show": function ($event) {
                _vm.dialogShow = $event
              },
            },
          })
        : _vm._e(),
      _vm.activeInfo
        ? _c("recruitmentMsg", {
            attrs: {
              activeInfo: _vm.activeInfo,
              tabsInfo: _vm.titles.slice(0, 1),
            },
            on: {
              pageTurn: function (val) {
                return _vm.handleCurrentChange(val, 0)
              },
            },
          })
        : _vm._e(),
      _vm._l(_vm.titles, function (item, i) {
        return [
          i >= 1 && i < 9 && item.num && _vm.activeInfo
            ? _c(
                "title-block",
                { key: i, attrs: { id: "bm" + item.label } },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mt-10" },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.tableDatas(item.moduleId),
                            "header-cell-style": {
                              background: "#fafafa",
                              color: "#333",
                            },
                            "tooltip-effect": "light",
                          },
                        },
                        [
                          _vm._l(
                            _vm.tableFields(item.moduleId),
                            function (item1, j) {
                              return [
                                item1.field != "rk"
                                  ? _c("el-table-column", {
                                      key: j,
                                      attrs: {
                                        label: item1.fieldName,
                                        align: "center",
                                        "show-overflow-tooltip": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm.whichType(scope.row[j]) ===
                                                "string"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.columnValue(
                                                            scope.row[j],
                                                            item.moduleId
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _vm.whichType(
                                                      scope.row[j]
                                                    ) === "object"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.columnValue(
                                                            scope.row[j],
                                                            item.moduleId
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _vm.whichType(
                                                      scope.row[j]
                                                    ) === "img"
                                                  ? _c("span", [
                                                      _c("img", {
                                                        staticStyle: {
                                                          width: "64px",
                                                        },
                                                        attrs: {
                                                          src: _vm.columnValue(
                                                            _vm.repliceHttps(
                                                              scope.row[j]
                                                            ),
                                                            item.moduleId
                                                          ),
                                                          alt: "",
                                                          srcset: "",
                                                        },
                                                      }),
                                                    ])
                                                  : _vm.whichType(
                                                      scope.row[j]
                                                    ) === "url"
                                                  ? _c("span", [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticStyle: {
                                                            color: "#409EFF",
                                                          },
                                                          attrs: {
                                                            href: _vm.columnValue(
                                                              scope.row[j],
                                                              item.moduleId
                                                            ),
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(scope.row[j])
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.columnValue(
                                                            scope.row[j],
                                                            item.moduleId
                                                          ) || "--"
                                                        ) + " "
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                      _c("pagination", {
                        attrs: {
                          pageNum: _vm.tablePage(item.moduleId),
                          total: _vm.tableTotal(item.moduleId),
                        },
                        on: {
                          currentChange: function (val) {
                            return _vm.handleCurrentChange(val, i)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      }),
      _vm.titles[9].num
        ? _c(
            "title-block",
            { attrs: { id: "bm" + _vm.titles[9].label } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[9].label)),
              ]),
              _c(
                "div",
                {
                  staticClass: "mt-10 mainProducts",
                  staticStyle: { "margin-top": "24px" },
                },
                [
                  _c(
                    "i",
                    { staticClass: "qhicon", on: { click: _vm.switchDisplay } },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/wordqhuan.svg"),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.switchDiaplayFlag,
                          expression: "switchDiaplayFlag",
                        },
                      ],
                      staticClass: "my-kw-echarts",
                    },
                    [
                      _c("div", {
                        style: { width: "100%", height: "400px" },
                        attrs: { id: "zxKeywordsCloud" },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.switchDiaplayFlag,
                          expression: "!switchDiaplayFlag",
                        },
                      ],
                      staticClass: "mainProductsWordsBox",
                    },
                    [_c("p", [_vm._v(_vm._s(_vm.mainProductsWords))])]
                  ),
                ]
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.titles[10].num && _vm.activeInfo
        ? _c(
            "title-block",
            { attrs: { id: "bm" + _vm.titles[10].label } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[10].label)),
              ]),
              _c(
                "div",
                {
                  staticClass: "mt-10 clearfix",
                  staticStyle: { "margin-top": "24px" },
                },
                [
                  _c(
                    "ul",
                    { staticClass: "product-list clearfix" },
                    _vm._l(
                      _vm.tableDatas(_vm.titles[10].moduleId),
                      function (item, index) {
                        return _c("li", { key: index }, [
                          _c(
                            "div",
                            { class: ["img", item[0] ? "" : "defalutImg"] },
                            [
                              item[0]
                                ? _c("img", { attrs: { src: item[0] } })
                                : _c("img", {
                                    attrs: {
                                      src: require("@/assets/defalut-img.png"),
                                    },
                                  }),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "textOverflow",
                              attrs: { title: item[1] },
                            },
                            [_vm._v(_vm._s(item[1]))]
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                  _c("pagination", {
                    attrs: {
                      pageNum: _vm.tablePage(_vm.titles[10].moduleId),
                      pageSize: 3,
                      total: _vm.tableTotal(_vm.titles[10].moduleId),
                    },
                    on: {
                      currentChange: function (val) {
                        return _vm.handleCurrentChange(val, 10)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._l(_vm.titles, function (item, i) {
        return [
          i >= 11 && i <= 15 && item.num && _vm.activeInfo
            ? _c(
                "title-block",
                { key: i, attrs: { id: "bm" + item.label } },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mt-10" },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.tableDatas(item.moduleId),
                            "header-cell-style": {
                              background: "#fafafa",
                              color: "#333",
                            },
                            "tooltip-effect": "light",
                          },
                        },
                        [
                          i == 7 || i == 10
                            ? _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  align: "center",
                                  width: "70",
                                },
                              })
                            : _vm._e(),
                          _vm._l(
                            _vm.tableFields(item.moduleId),
                            function (item1, j) {
                              return [
                                item1.field != "rk"
                                  ? _c("el-table-column", {
                                      key: j,
                                      attrs: {
                                        label: item1.fieldName,
                                        align: "center",
                                        "show-overflow-tooltip": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                item1.fieldName == "二维码"
                                                  ? [
                                                      _vm.isEmpty(scope.row[j])
                                                        ? _c("span", [
                                                            _vm._v("--"),
                                                          ])
                                                        : _c(
                                                            "el-popover",
                                                            {
                                                              attrs: {
                                                                placement:
                                                                  "left",
                                                                "popper-class":
                                                                  "auto-width",
                                                                trigger:
                                                                  "hover",
                                                                width: "auto",
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "qrcode-img",
                                                                attrs: {
                                                                  src: scope
                                                                    .row[j],
                                                                },
                                                              }),
                                                              _c("img", {
                                                                staticClass:
                                                                  "qr-code-holder",
                                                                attrs: {
                                                                  slot: "reference",
                                                                  src: "/static/image/qrcode.png",
                                                                },
                                                                slot: "reference",
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  : [
                                                      _vm.whichType(
                                                        scope.row[j]
                                                      ) === "string"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.columnValue(
                                                                  scope.row[j],
                                                                  item.moduleId
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.whichType(
                                                            scope.row[j]
                                                          ) === "object"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.columnValue(
                                                                  scope.row[j],
                                                                  item.moduleId
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.whichType(
                                                            scope.row[j]
                                                          ) === "img"
                                                        ? _c("span", [
                                                            _c("img", {
                                                              staticStyle: {
                                                                width: "100%",
                                                                "max-width":
                                                                  "64px",
                                                              },
                                                              attrs: {
                                                                src: _vm.columnValue(
                                                                  _vm.repliceHttps(
                                                                    scope.row[j]
                                                                  ),
                                                                  item.moduleId
                                                                ),
                                                                alt: "",
                                                                srcset: "",
                                                              },
                                                            }),
                                                          ])
                                                        : _vm.whichType(
                                                            scope.row[j]
                                                          ) === "url"
                                                        ? _c("span", [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: scope
                                                                    .row[j],
                                                                  target:
                                                                    "_blank",
                                                                  rel: "noopener noreferrer",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.columnValue(
                                                                      scope.row[
                                                                        j
                                                                      ],
                                                                      item.moduleId
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.columnValue(
                                                                  scope.row[j],
                                                                  item.moduleId
                                                                ) || "--"
                                                              ) + " "
                                                            ),
                                                          ]),
                                                    ],
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                      _c("pagination", {
                        attrs: {
                          pageNum: _vm.tablePage(item.moduleId),
                          total: _vm.tableTotal(item.moduleId),
                        },
                        on: {
                          currentChange: function (val) {
                            return _vm.handleCurrentChange(val, i)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      }),
      _vm.titles[16].num && _vm.activeInfo
        ? _c(
            "title-block",
            { attrs: { id: "bm建站网站" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[16].label)),
              ]),
              _c(
                "div",
                {
                  staticClass: "tables mt-10",
                  staticStyle: { "margin-top": "16px" },
                },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.tableDatas(_vm.titles[16].moduleId),
                        "header-cell-style": {
                          background: "#fafafa",
                          color: "#333",
                        },
                        "tooltip-effect": "light",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          align: "center",
                          width: "70",
                        },
                      }),
                      _vm._l(
                        _vm.tableFields(_vm.titles[16].moduleId),
                        function (item, i) {
                          return [
                            item.field != "rk"
                              ? _c("el-table-column", {
                                  key: i,
                                  attrs: {
                                    label: item.fieldName,
                                    align: "center",
                                    "show-overflow-tooltip": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            item.field == "homeUrl"
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass: "textOverflow",
                                                    staticStyle: {
                                                      width: "100%",
                                                      color: "#409eff",
                                                    },
                                                    attrs: {
                                                      rel: "noopener noreferrer",
                                                      underline: false,
                                                      href: _vm.addUrl3W(
                                                        _vm.columnValue(
                                                          scope.row[i],
                                                          _vm.titles[16]
                                                            .moduleId
                                                        )
                                                      ),
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.addUrl3W(
                                                          _vm.columnValue(
                                                            scope.row[i],
                                                            _vm.titles[16]
                                                              .moduleId
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.columnValue(
                                                        scope.row[i],
                                                        _vm.titles[16].moduleId
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                  _c("pagination", {
                    attrs: {
                      pageNum: _vm.titles[16].pageNum,
                      total: _vm.tableTotal(_vm.titles[16].moduleId),
                    },
                    on: {
                      currentChange: function (val) {
                        return _vm.handleCurrentChange(val, 16)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.activeInfo
        ? _c("businessBox", {
            attrs: {
              activeInfo: _vm.activeInfo,
              tabsInfo: _vm.titles.slice(17, 21),
            },
            on: { pageTurn: _vm.handleCurrentChange },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }